import { ListStyle } from '@yleisradio/areena-types';

type SupportedListStyleImage = '16:9' | '9:13' | '1:1';

const gradients: {
  [key in SupportedListStyleImage]?: (color?: string) => string;
} = {
  '16:9': color =>
    `linear-gradient(${color || 'rgb(255, 255, 255)'}, rgb(0, 0, 0) 92%)`,
  '9:13': color =>
    `linear-gradient(${color || 'rgb(255, 255, 255)'}, rgb(26, 27, 28))`,
  '1:1': color =>
    `linear-gradient(${color || 'rgb(255, 255, 255)'}, rgb(0, 0, 0) 92%)`,
};

export const getGradientBackground = (
  imageStyle: ListStyle['image'],
  color?: string
): string => {
  if (isSupportedListStyleImage(imageStyle)) {
    return (gradients[imageStyle] || (() => ''))(color);
  }

  return '';
};

export const isSupportedListStyleImage = (
  image: ListStyle['image']
): image is SupportedListStyleImage => {
  return Boolean(image && ['16:9', '9:13', '1:1'].includes(image));
};

export const is_16_9_image = (listStyle: ListStyle | undefined): boolean => {
  if (listStyle === undefined) {
    return true;
  }
  if (listStyle.image === '16:9') {
    return true;
  }
  return false;
};
export const is_9_13_image = (listStyle: ListStyle | undefined): boolean => {
  if (listStyle === undefined) {
    return false;
  }
  if (listStyle.image === '9:13') {
    return true;
  }
  return false;
};

export const is_1_1_image = (listStyle: ListStyle | undefined): boolean => {
  if (listStyle === undefined) {
    return false;
  }
  if (listStyle.image === '1:1') {
    return true;
  }
  return false;
};

export const isHorizontalLayout = (
  listStyle: ListStyle | undefined
): boolean => {
  return listStyle?.layout === undefined || listStyle.layout === 'horizontal';
};

export const isGridLayout = (listStyle: ListStyle | undefined): boolean => {
  return listStyle?.layout === 'grid';
};

export function getGridWidth(listStyle: ListStyle | undefined): number | null {
  if (!isGridLayout(listStyle)) return null;

  return listStyle?.image === '1:1' ? 6 : 4;
}
